module.exports = __webpack_public_path__ + "static/media/17_Bild_3_infografik-xosoft.1f7e81a6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle17/17_Bild_3_infografik-xosoft.jpg
 ** module id = 160
 ** module chunks = 0
 **/